import { combineReducers } from 'redux';

import statusChange from './report/reducer';

export default combineReducers({
  statusChange,
});



// WEBPACK FOOTER //
// ./src/pages/statuschange/state/reducer.js